import React from "react";
import { Col } from "reactstrap";
import ShortcutModal from "./ShortcutModal";
import { useTranslation } from "react-i18next";
import { FiBell, FiCheckCircle, FiXCircle, FiInfo, FiHome, FiUser } from "react-icons/fi";

const Notifs = () => {
  const { t } = useTranslation();

  // Sample notifications data (در آینده از API میاد)
  const notifications = [
    {
      id: 1,
      title: t("خوش آمدید"),
      message: t("به پلتفرم مدیریت خانه هوشمند ماندگار خوش آمدید"),
      type: "success",
      date: "امروز",
      isRead: false,
    },
  ];

  const getIconByType = (type) => {
    switch (type) {
      case "success":
        return <FiCheckCircle size={18} />;
      case "error":
        return <FiXCircle size={18} />;
      case "pending":
        return <FiUser size={18} />;
      default:
        return <FiInfo size={18} />;
    }
  };

  const getIconClass = (type) => {
    switch (type) {
      case "success":
        return "notif-icon-success";
      case "error":
        return "notif-icon-error";
      case "pending":
        return "notif-icon-warning";
      default:
        return "notif-icon-info";
    }
  };

  // گروه‌بندی نوتیفیکیشن‌ها بر اساس تاریخ
  const groupedNotifs = notifications.reduce((groups, notif) => {
    const date = notif.date;
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(notif);
    return groups;
  }, {});

  return (
    <div className="notif-container-top" style={{ padding: "24px", minHeight: "auto" }}>
      <h2 className="setting-title">{t("پیام های من")}</h2>

      {/* Notifications List */}
      <div className="notifs-list-container">
        {Object.keys(groupedNotifs).map((date, dateIndex) => (
          <div key={dateIndex} className="notif-group">
            <div className="notif-date-badge">
              <span>{date}</span>
            </div>
            
            {groupedNotifs[date].map((notif) => (
              <div key={notif.id} className={`notif-item ${notif.isRead ? "read" : "unread"}`}>
                <div className={`notif-icon ${getIconClass(notif.type)}`}>
                  {getIconByType(notif.type)}
                </div>
                <div className="notif-content">
                  <p className="notif-title">{notif.title}</p>
                  <p className="notif-message">{notif.message}</p>
                </div>
                {notif.type === "pending" && (
                  <div className="notif-actions">
                    <button className="notif-btn-accept">
                      <FiCheckCircle size={14} />
                      <span>{t("تائید")}</span>
                    </button>
                    <button className="notif-btn-reject">
                      <FiXCircle size={14} />
                      <span>{t("رد")}</span>
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        ))}

        {/* Empty State */}
        {notifications.length === 0 && (
          <div className="notif-empty-state">
            <FiBell size={48} />
            <p>{t("پیامی وجود ندارد")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export { Notifs };